export function trackAuthentication(userUuid: string) {
    window.fretebrasAnalytics = window.fretebrasAnalytics || []

    const data = {
        user_info: {
            source_user_id: 'Caminhoneiro',
            login_status: 'LG',
            user_type: 'Caminhoneiro',
            user_domain: 'window.location.hostname',
            user_id: `Caminhoneiro${userUuid}`
        }
    }

    window.fretebrasAnalytics.push(data)
}